import { defineComponent as _defineComponent } from 'vue'
import { DataInstance, Userspaces, Meetings, InviteLinks } from '@busy-human/opt-library'
import { ref, computed, onMounted } from 'vue'
import { ISOTimestamp } from '@busy-human/gearbox'
import moment, { Moment } from 'moment';
import { ISOTimeChunk, DayWithMomentChunk } from "./meeting-request-types";
import timeScroller from './time-scroll.vue'
import { Functions } from 'firebase/functions';

type Props = {
    invite: InviteLinks.Model
    request: Meetings.Model
    checkPreviousDay: Function
}
type Emits = {
    (e: 'update:request', request: Meetings.Model): void
    (e: 'previous'): void
    (e: 'progress'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'time-selector',
  props: {
    invite: null,
    request: null,
    checkPreviousDay: null
  },
  emits: ["update:request", "previous", "progress"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'update:request', request: Meetings.Model): void
    (e: 'previous'): void
    (e: 'progress'): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    invite: InviteLinks.Model
    request: Meetings.Model
    checkPreviousDay: Function
}



const isAvailableTimes = ref(true)

onMounted(()=>{
    if(props.checkPreviousDay)
        isPreviousDay.value = props.checkPreviousDay()
})


const selectedTime = ref<DayWithMomentChunk>()
const selectedTimeString = ref<string>("")
const isPreviousDay = ref(false)

const previous = () => {
    emit('previous');
}

const proceed = () => {
    emit('progress');
}
const setSelectedTime = (selectedChunk: DayWithMomentChunk)=>{
    // let tmpMeeting = Meetings.Defaults()
    let tmpMeeting = props.request
    let startTime = moment(selectedChunk.timeChunk.startTime);
    tmpMeeting.startTime = startTime.toISOString();
    selectedTime.value = selectedChunk;
    let splitDay= selectedTime.value.day.split(",")
    let day = splitDay[0]
    let time = selectedTime.value.timeChunk.startTime.format("h:mma")
    selectedTimeString.value = `${day} at ${time}`
    emit('update:request',tmpMeeting)
}

const updateIsAvailableTimes = (value:boolean) =>{
    isAvailableTimes.value = value
}


const __returned__ = { props, isAvailableTimes, emit, selectedTime, selectedTimeString, isPreviousDay, previous, proceed, setSelectedTime, updateIsAvailableTimes, DataInstance, Userspaces, Meetings, InviteLinks, ref, computed, onMounted, ISOTimestamp, moment, Moment, ISOTimeChunk, DayWithMomentChunk, timeScroller, Functions }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})